import React from 'react'
import { Link } from "react-router-dom";

import "./Navbar.css";

import kps_admissionform from "../images/KPS_e-Admission Form.pdf";
import Fees from '../pages/Fees';
// import TrustRegistration from '../pages/TrustRegistration';

function Navbar() {
  const phoneNumber = "917407015551"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${917407015551}?text=${encodedMessage}`;

  return (
    <div>
      <div className='fixed-top'>
        <div className="bestschoolkrishngar">
          <div className="album py-2">

            <div className="container">

              <div className="row ">
                <div className="col-md-8 mt-1">




                  <div className="d-flex justify-content-between align-items-center mb-0">
                    <a style={{ color: "white" }} href={kps_admissionform} className='' target="_blank" rel="noopener noreferrer"><small>Admission Form <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down blink" viewBox="0 0 16 16">
                      <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                    </svg></small></a>
                    <a style={{ color: "white" }} href=''>kpsnadia@gmail.com </a>






                  </div>


                </div>

                <div className="col-md-4 mt-1 ">
                  <a className="bestcbscschoolnadia me-2" ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" className="bi bi-telephone-minus" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                  </svg> 8001110006 / 7407015551 / 7407028080  </a>

                  <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
                    <button style={{ padding: "4px 9px", backgroundColor: "#1B8755", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg>
                    </button>
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg navbar-white bg-white ">
          <div className="container-fluid">

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">

                  <a className="nav-link active" aria-current="page" href="/"><b className='home'>Home</b></a>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>About us</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="aboutus">About us</a></li>
                    <li><a className="dropdown-item" href="brief-History">A Brief History</a></li>

                    <li><a className="dropdown-item" href="mission">Mission</a></li>

                    <li><a className="dropdown-item" href="Vision">Vision</a></li>
                    <li><a className="dropdown-item" href="Ourteam">Our Team</a></li>
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Academics</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="Pre-Primary">Pre-Primary Programme </a></li>
                    <li><a className="dropdown-item" href="SeniorSecondary">Primary to Senior Secondary </a></li>
                    <li><a className="dropdown-item" href="Teaching-learningMethod">Teaching and Learning Methodology </a></li>
                    <li><a className="dropdown-item" href="Booklist">Booklist  </a></li>
<li><a className="dropdown-item" href="syllabus"> Syllabus </a></li>
                    <li><a className="dropdown-item" href="School&class-timing">School Timing </a></li>
                    <li><a className="dropdown-item" href="Academic-calendar">Academic Calendar </a></li>
                    <li><a className="dropdown-item" href="Morning-Prayer">Morning Prayer</a></li>
                    <li><a className="dropdown-item" href="rulesandregulations">Rules and Regulations</a></li>


                  </ul>
                </li>

                {/* <li className="nav-item">
          <a className="nav-link" href="Awards-recognition"> <b className='home'>Awards & Recognition</b></a>
        </li> */}


                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Admission</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    {/* <li><a className="dropdown-item" href="Agecriteria-forAdmisiion">Age Criteria For Admission </a></li> */}
                    <li><a className="dropdown-item" href="Criteria-ofAdmission">Criteria of Admission </a></li>
                    <li><a className="dropdown-item" href="admission-procedure">Admission Procedure</a></li>
                    <li><hr class="dropdown-divider" /></li>
                    <li><a className="dropdown-item" href="Admissiontest-interview">Admission Text / Interview</a></li>
                    <li><a className="dropdown-item" href="Documentsrequired">Document Required for Admission</a></li>
                    <li><a className="dropdown-item" href="FeesStructure">Fees Structure</a></li>
                           <li><a className="dropdown-item" href="SubjectCombination_class_XI"> Subject Combinations for Class XI</a></li>
                   
                  </ul>
                </li>



                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>CBSE-Mandatory Disclosures</b>
                  </a>

                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <div
                      style={{
                        height: '450px',
                        overflowY: 'scroll',
                        border: '0px solid #ccc',
                        padding: '1rem',
                      }}
                    >

                      <li><a className="dropdown-item " href="Academic-calendar">Academic Celendar </a></li>
                      <li><a className="dropdown-item" href="FeesStructure">Fees Structure</a></li>
                      <li><a className="dropdown-item" href="trust-registration">Trust Registration</a></li>
                      <li><a className="dropdown-item" href="NoObjection-certificate"> No Objection Certificate</a></li>
                      <li><a className="dropdown-item" href="Recognition-certificate"> Recognition Certificate</a></li>
                      <li><a className="dropdown-item" href="deocertificate"> DEO Certificate</a></li>
                      <li><a className="dropdown-item" href="Affiliation-letter"> Affiliation Letter</a></li>
                      <li><a className="dropdown-item" href="Listofsmc"> List of SMC</a></li>
                      <li><a className="dropdown-item" href="boardreslut"> Board Result</a></li>
                      <li><a className="dropdown-item" href="PtaMembers">  List of PTA Members</a></li>
                      <li><a className="dropdown-item" href="Structural-Stability"> Structural Stability</a></li>
                      <li><a className="dropdown-item" href="Drinkingwater-Sanitation">Drinking Water and Sanitation</a></li>
                      <li><a className="dropdown-item" href="Firesafety"> Fire Safety</a></li>
                      <li><a className="dropdown-item" href="LandDocument"> Land Document</a></li>
                        <li><a className="dropdown-item" href="#"> Self Certification</a></li>
                      
                      <li><a className="dropdown-item" href="Mandatory-PublicDisclosure"> Mandatory Public Disclosure Link</a></li>
                      <br />

                    </div>
                  </ul>

                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Co-Curriculum</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="#">Club</a></li>
                    <li><a className="dropdown-item" href="#">Project</a></li>

                    <li><a className="dropdown-item" href="">Excurssions</a></li>



                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Activities</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="#">Teaching Method</a></li>
                    <li><a className="dropdown-item" href="#">Workshop</a></li>

                    <li><a className="dropdown-item" href="#">Career</a></li>
                    <li><a className="dropdown-item" href="#">Counselling</a></li>
                    <li><a className="dropdown-item" href="#">School Initiatives</a></li>
                    <li><a className="dropdown-item" href="#">Music</a></li>
                    <li><a className="dropdown-item" href="#">Worksheets</a></li>



                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'> Transfer Certificate</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="#">Class X</a></li>
                    <li><a className="dropdown-item" href="#">Class III</a></li>



                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'> Events</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="video-gallery">Upcoming</a></li>
                    <li><a className="dropdown-item" href="video-gallery">Recent</a></li>
                    <li><a className="dropdown-item" href="video-gallery">Archive</a></li>
                    <li><a className="dropdown-item" href="video-gallery">Video</a></li>
                    <li><a className="dropdown-item" href="Photogallery">Photo</a></li>


                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Contact us</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="contactus">Contact us </a></li>
                    <li><a className="dropdown-item" href="Visiting-hours">Visiting Hours </a></li>

                  </ul>
                </li>

              </ul>
              {/* <a href='tel: 08001110006'>
        <button className="helpline" type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708"/>
</svg> Help Line Number</button>
        </a> */}

            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar